import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
import { defineComponent, ref, watch } from 'vue';
import { downloadImage } from '@/utils';
export default defineComponent({
  name: 'UserCertificate',
  props: {
    show: {
      type: Object,
      required: true
    },
    userExamId: {
      type: Number,
      required: true
    }
  },
  setup: function (props) {
    var daoService = useService(DaoService);
    var imageUrl = ref('');
    watch(function () {
      return props.show.visible;
    }, function (visible) {
      if (visible) {
        daoService.getUserCertificate(props.userExamId).then(function (res) {
          imageUrl.value = res.userCertificate;
        });
      }
    });
    var onDownloadClick = function () {
      downloadImage(imageUrl.value, '我的证书');
    };
    return {
      imageUrl: imageUrl,
      onDownloadClick: onDownloadClick
    };
  }
});